export class Ask {
    public product_id: number;
    public question: string;
    public email: string;
}


// WEBPACK FOOTER //
// ./src/models/ask.ts